import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/tuyen-dung/dang-tuyen'
const YC = '/tuyen-dung/yeu-cau-tuyen-dung'

// Lọc danh sách đăng tuyển
export function locDangTuyen(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách đăng tuyển đang hoạt động
export function layDanhSachDangTuyenDangHoatDong() {
  try {
    return axiosApi.get(`${BASE}/hoat-dong`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách đăng tuyển theo yêu cầu tuyển dụng
export function layDanhSachDangTuyenTheoYeuCau(recruitmentRequestId: number) {
  try {
    return axiosApi.get(`${YC}/${recruitmentRequestId}/danh-sach-dang-tuyen`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết đăng tuyển
export function layChiTietDangTuyen(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo đăng tuyển
export function taoDangTuyen(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật đăng tuyển
export function capNhatDangTuyen(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa đăng tuyển
export function xoaDangTuyen(id: number) {
  try {
    return axiosApi.delete(`${BASE}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
